import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardContainer } from '../../dashboard.container';
import { ActivatedRoute, Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScriptLoader } from '../../../../shared/components/scriptLoader';

@Component({
    selector: 'app-my-requests',
    templateUrl: 'requests.component.html',
    styleUrls: ['./requests.component.css', './requests.component.scss', '../../dashboard.component.css']
})

export class RequestsComponent implements OnInit, OnDestroy {

    constructor(private route: ActivatedRoute, private dashboardContainer: DashboardContainer, private router: Router,
        private angulartics2: Angulartics2, private spinner: NgxSpinnerService, private scriptLoader: ScriptLoader) { }

    ngOnInit() {
        this.scriptLoader.ngOnInit(); // loads the tawk.to injectable
        this.spinner.show();
        this.route.params.subscribe(params => {
            if (params.vvm) {
                this.angulartics2.eventTrack.next({ action: 'dashBoardReqsFromEmail' });
                this.router.navigate(['/my-dashboard/my-requests']);
            } else {
                this.dashboardContainer.changeHeader();
                this.dashboardContainer.getAllActiveRequestsByUser().then(result => {
                    this.spinner.hide();
                });
            }
        });
    }

    goBack() {
        window.history.back();
    }

    ngOnDestroy() {
        this.scriptLoader.ngOnDestroy();
    }

    getActiveRequests = () => this.dashboardContainer.allRequests;

    removeRequest(requestId) {
        this.dashboardContainer.removeRequest(requestId);
    }

    newRequest() {
        this.router.navigate(['/search']);
    }

    isMobile = () => (window.innerWidth < 992) ? true : false;

}
